import { FC } from 'react';
import { Box, ListItem, UnorderedList, Text } from '@chakra-ui/react';

import { CustomerForNotification } from 'types/customer';
import { ReadonlyCustomerListHeader } from './ReadonlyCustomerListHeader';
import { ReadonlyCustomerListItem } from './ReadonlyCustomerListItem';

type Props = {
  selectedCustomers: CustomerForNotification[];
  selectedCustomersLength: number;
};

export const ReadonlyCustomerList: FC<Props> = ({
  selectedCustomers,
  selectedCustomersLength,
}) => (
  <Box m="20px 0 0 0px" w="95%">
    {/* 顧客一覧のヘッダ */}
    <ReadonlyCustomerListHeader />
    {/* 顧客一覧 */}
    <UnorderedList maxH="400px" overflowY="auto">
      {selectedCustomers.map((item) => (
        <ListItem key={item.id} listStyleType="none">
          <ReadonlyCustomerListItem item={item} />
        </ListItem>
      ))}
    </UnorderedList>
    {/* 顧客一覧のフッタ */}
    <Text color="gray.500" textAlign="end" mt="10px" mr="20px">
      データ件数: {selectedCustomersLength}
    </Text>
  </Box>
);
